import pickObject from "../../common-utils/object/pickObject.util.js";
export const filterPropsUtil = (props, ...passThroughProps) => pickObject(props, ["id", "className", "data-testid", ...passThroughProps]);
export default filterPropsUtil;
